<template>
  <vs-popup class="user-edit-popup" id="popup" title="CREATE HELP TAG CATEGORY" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Category Name</small>
                <vs-input v-model="createStaffForm.name" name="name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="createStaffForm.description" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const TenantRepository = RepositoryFactory.get('tenant');
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const HelpTagRepository = RepositoryFactory.get('helpTag')

function initialState() {
  return {
    open: false,
    createStaffForm: {},
    currencyList: {},
    id: null
  }
}

export default {
  name: 'CreateHelpTagCategoryPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },

  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        if (id) {
          this.id = id
          await this.fetchCategoryDetails()
        }
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },

    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        if (this.id) {
          await HelpTagRepository.updateHelpTagCategory(this.id, this.createStaffForm)
        } else {
          await HelpTagRepository.createHelpTagCategory(this.createStaffForm)
        }
        this.showSuccessMessage(`Category ${this.id ? 'updated' : 'created'} successfully`)
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close()
      }
      
    },
    async fetchCategoryDetails() {
      try {
        const { data } = (await HelpTagRepository.getTagCategoryDetails(this.id)).data
        this.createStaffForm = data
      } catch (error) {

      }
    },
    onClickReset() {
      this.createStaffForm = {}
    }
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
